import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 4rem 0;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const TableWrap = styled.div`
  width: 100%;
  max-width: 80rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const IconTextWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 0.6rem;
  font-weight: bold;
`;

export const Table = styled.div`
  width: 100%;
  border-collapse: collapse;
`;

export const TableHeader = styled.div`
  display: flex;
  width: 100%;
  font-size: 1.6rem;
  font-weight: bold;
  background-color: #f8f8f8;
  padding: 1rem 0;
  border-bottom: 2px solid #000;
  border-radius: 1.2rem 1.2rem 0 0;
`;

export const TableRow = styled.div`
  display: flex;
  width: 100%;
  font-size: 1.4rem;
  font-weight: normal;
  padding: 1rem 0;
  border-bottom: 1px solid #ccc;
  cursor: pointer;

  &:nth-child(even) {
    background-color: #f9f9f9;
  }

  &:hover {
    background-color: #ccc;
  }
`;

export const TableCell = styled.div`
  flex: 1;
  text-align: center;
  padding: 0.8rem 0;
`;

export const CellWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TableBody = styled.div`
  width: 100%;
  max-height: 74dvh;
  overflow-y: auto;
`;
